import styled, { css } from 'styled-components';
import { fadeInAndUp } from '../base/keyframes/fades';
import { sequencedAnimationDelay } from '../base/utils';
import { Column } from '../base';
import media from '../base/media';

export const Wrapper = styled.div`
	padding: 6rem 0;
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;
	perspective: 1000;
	-webkit-perspective: 1000;
	transform: translate3d(0, 0, 0);

	${media.tablet`
		padding: 14rem 0;
	`}
`;

export const AnimatedColumn = styled(Column)`
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;
	perspective: 1000;
	-webkit-perspective: 1000;
	transform: translate3d(0, 0, 0);
	${({ useAnimation }) => useAnimation && css`
		opacity: 0;
		animation: ${fadeInAndUp} 300ms;
		animation-fill-mode: forwards;
		${sequencedAnimationDelay(10, 0.03)};
	`}
`;

export const ErrorWrapper = styled.div`
	display: flex;
	justify-content: center;
`;
